import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CheckedIcon from "../../../../Img/checked-icon.png";
import RightArrowImg from "../../../../Img/button-arrow.png";
import { formatDateToDDMMYYYY } from "utils/CommonFunctions";
import EditIconImg from "../../../../Img/edit-patient-icon.png";
import ViewIconImg from "../../../../Img/view-patient-details.png";

import { PlusOutlined } from "@ant-design/icons";
import EmbryoBank from "../../../../Img/embryo-bank.png";
import { sendDataToSocket } from "socket/SocketComponent";
import LutealPhase from "../../../../Img/luteal-phase.png";
import AddDocuments from "../../../../Img/add-documents.png";
import CycleOutCome from "../../../../Img/cycle-out-come.png";
import IVFFlowSheet from "../../../../Img/IVF-flow-sheet.png";
import SemenAnalysis from "../../../../Img/semen-analysis.png";
import DischargeCard from "../../../../Img/discharge-card.png";
import IVFProSoftLogo10 from "../../../../Img/IVFProSoftLogo10.png";
import PGSDischargeCard from "../../../../Img/PGS-discharge-card.png";
import PatientRegistration from "../../../../Img/patient-registration.png";
import EmbryologyDataSheet from "../../../../Img/embryology-data-sheet.png";
import PatientBasicHistory from "../../../../Img/patient-basic-history.png";
// import TimelineDataNoFound from "../../../../Img/timeline-data-no-found.png";
import { setPatientEdit } from "redux/reducers/SearchPanel/globalSearch.slice";
import TESAPESADischargeCard from "../../../../Img/TESAPESA-discharge-card.png";
import PatientExtendedHistory from "../../../../Img/patient-extended-history.png";
// import DarkTimelineDataNoFound from "../../../../Img/dark-timeline-data-no-found.png";
import MaleInfertilityInvestigation from "../../../../Img/male-infertility-investigation.png";
import FemaleInfertilityInvestigation from "../../../../Img/female-infertility-investigation.png";
import {
  getPermissionLocationWise,
  setSelectedLocation,
} from "redux/reducers/Role/role.slice";
import { useNavigate } from "react-router-dom";
import DNAModal from "./PatientJourneyModal/DNAModal";
import IUIModal from "./PatientJourneyModal/IUIModal";
import SFreezingModal from "./PatientJourneyModal/SFreezingModal";
import { setSelectedModuleTab } from "redux/reducers/common.slice";
import IvfFlowSheetModal from "./PatientJourneyModal/IvfFlowSheetModal";
import SemenAnalysisModal from "./PatientJourneyModal/SemenAnalysisModal";
import {
  dashboardViewPatientInfo,
  setActivePatientJourneyModuleDetails,
} from "redux/reducers/Dashboard/dashboard.slice";
import EmbryologyDataSheetModal from "./PatientJourneyModal/EmbryologyDataSheetModal";
import PatientRegistrationModal from "./PatientJourneyModal/PatientRegistrationModal";
import PatientBasicHistoryModal from "./PatientJourneyModal/PatientBasicHistoryModal";
import PatientExtendedHistoryModal from "./PatientJourneyModal/PatientExtendedHistoryModal";
import MaleInfertilityInvestigationModal from "./PatientJourneyModal/MaleInfertilityInvestigationModal";
import FemaleInfertilityInvestigationModal from "./PatientJourneyModal/FemaleInfertilityInvestigationModal";
import SSTModal from "./PatientJourneyModal/SSTModal";
import DischargeCardModal from "./PatientJourneyModal/DischargeCardModal";
import LutealPhaseModal from "./PatientJourneyModal/LutealPhaseModal";
import EmbryoBankModal from "./PatientJourneyModal/EmbryoBankModal";
import CycleOutComeModal from "./PatientJourneyModal/CycleOutComeModal";
import PGTDischargeCardModal from "./PatientJourneyModal/PGTDischargeCardModal";
import TesaPesaDischargeCardModal from "./PatientJourneyModal/TesaPesaDischargeCardModal";

const handleModuleWiseIcon = (icon) => {
  switch (icon) {
    case 1:
      return PatientRegistration;
    case 2:
      return PatientBasicHistory;
    case 3:
      return PatientExtendedHistory;
    case 4:
      return MaleInfertilityInvestigation;
    case 5:
      return FemaleInfertilityInvestigation;
    case 6:
      return IVFFlowSheet;
    case 7:
      return EmbryologyDataSheet;
    case 8:
      return SemenAnalysis;
    case 9:
      return DischargeCard;
    case 10:
      return LutealPhase;
    case 11:
      return EmbryoBank;
    case 12:
      return CycleOutCome;
    case 13:
      return PGSDischargeCard;
    case 14:
      return TESAPESADischargeCard;
    case 15:
      return AddDocuments;
    default:
      return PatientRegistration;
  }
};

// const completed_pages = [
//   {
//     name: "Patient Registration",
//     count: 1,
//     icon: 1,
//     path: "/patient-registration",
//     entries: [
//       {
//         _id: "666c2455f471447f9e671510",
//         ivf_id: null,
//         ivf_flow_id: null,
//         created_at: "2024-06-14T11:07:01.466Z",
//         updated_at: "2025-09-23T12:27:14.025Z",
//       },
//     ],
//   },
//   {
//     name: "Patient Basic History",
//     count: 1,
//     icon: 2,
//     path: "/patient-basic-history",
//     entries: [
//       {
//         _id: "6685456858aa7f06c7801d16",
//         ivf_id: null,
//         ivf_flow_id: null,
//         created_at: "2025-04-17T10:26:44.581Z",
//         updated_at: "2025-04-17T10:26:44.581Z",
//       },
//     ],
//   },
//   {
//     name: "Patient Extended History",
//     count: 1,
//     icon: 3,
//     path: "/patient-extended-history",
//     entries: [
//       {
//         _id: "668546e058aa7f06c7801d78",
//         ivf_id: null,
//         ivf_flow_id: null,
//         created_at: "2024-07-03T12:41:04.982Z",
//         updated_at: "2024-07-09T05:21:59.521Z",
//       },
//     ],
//   },
//   {
//     name: "Male Infertility Investigation",
//     count: 1,
//     icon: 4,
//     path: "/male-infertility-investigation",
//     entries: [
//       {
//         _id: "6685474258aa7f06c7801dbf",
//         ivf_id: null,
//         ivf_flow_id: null,
//         created_at: "2024-07-03T12:42:41.480Z",
//         updated_at: "2025-04-16T12:09:05.930Z",
//       },
//     ],
//   },
//   {
//     name: "Female Infertility Investigation",
//     count: 1,
//     icon: 5,
//     path: "/female-infertility-investigation",
//     entries: [
//       {
//         _id: "668547de58aa7f06c7801e02",
//         ivf_id: null,
//         ivf_flow_id: null,
//         created_at: "2024-07-03T12:45:17.507Z",
//         updated_at: "2025-09-29T06:29:04.962Z",
//       },
//     ],
//   },
//   {
//     name: "IVF Flow Sheet",
//     count: 5,
//     icon: 6,
//     path: "/ivf-flow-sheet",
//     entries: [
//       {
//         _id: "66ab6001c371f7e281251b40",
//         ivf_id: "2024/8/268-1",
//         ivf_flow_id: "66ab6001c371f7e281251b40",
//         created_at: "2024-08-01T10:14:24.497Z",
//         updated_at: null,
//       },
//       {
//         _id: "67ca8c11cc105180b3113f63",
//         ivf_id: "2024/8/268-2",
//         ivf_flow_id: "67ca8c11cc105180b3113f63",
//         created_at: "2024-08-07T06:02:55.697Z",
//         updated_at: "2025-11-04T06:09:11.689Z",
//       },
//       {
//         _id: "66ab4bf3c371f7e281251839",
//         ivf_id: "2024/8/268-3",
//         ivf_flow_id: "66ab4bf3c371f7e281251839",
//         created_at: "2024-08-21T08:48:50.075Z",
//         updated_at: "2024-08-21T08:48:50.075Z",
//       },
//       {
//         _id: "66ab5fbbc371f7e281251b02",
//         ivf_id: "2024/3/268-1",
//         ivf_flow_id: "66ab5fbbc371f7e281251b02",
//         created_at: "2025-03-01T10:13:14.392Z",
//         updated_at: "2025-10-14T12:27:35.877Z",
//       },
//       {
//         _id: "68d4dc0a794cbc18480319e8",
//         ivf_id: "2025/9/268-1",
//         ivf_flow_id: "68d4dc0a794cbc18480319e8",
//         created_at: "2025-09-25T06:07:05.032Z",
//         updated_at: "2025-11-05T09:52:08.571Z",
//       },
//     ],
//   },
//   {
//     name: "Embryology Data Sheet",
//     count: 3,
//     icon: 7,
//     path: "/embryology-data-sheet",
//     entries: [
//       {
//         _id: "6814966232521acc486b4205",
//         ivf_id: "2024/8/268-2",
//         ivf_flow_id: "67ca8c11cc105180b3113f63",
//         created_at: "2025-05-02T09:54:41.130Z",
//         updated_at: "2025-10-02T12:22:24.157Z",
//       },
//       {
//         _id: "68679aea97d6724ef9be2a41",
//         ivf_id: "2024/3/268-1",
//         ivf_flow_id: "66ab5fbbc371f7e281251b02",
//         created_at: "2025-07-04T09:12:08.875Z",
//         updated_at: "2025-10-02T12:20:17.044Z",
//       },
//       {
//         _id: "68d4dc95794cbc1848031a25",
//         ivf_id: "2025/9/268-1",
//         ivf_flow_id: "68d4dc0a794cbc18480319e8",
//         created_at: "2025-09-25T06:09:24.326Z",
//         updated_at: "2025-10-02T12:15:05.495Z",
//       },
//     ],
//   },
//   {
//     name: "Semen Analysis",
//     count: 2,
//     icon: 8,
//     path: "/semen-analysis",
//     entries: [
//       {
//         _id: "6822e9a1b95a01525528799a",
//         ivf_id: null,
//         ivf_flow_id: null,
//         created_at: "2025-05-13T06:41:36.405Z",
//         updated_at: null,
//       },
//       {
//         _id: "68dfb56a393dda4e17f458cc",
//         ivf_id: null,
//         ivf_flow_id: null,
//         created_at: "2025-10-03T11:37:13.117Z",
//         updated_at: "2025-10-03T11:45:02.088Z",
//       },
//     ],
//   },
//   {
//     name: "Sperm Freezing",
//     count: 1,
//     icon: 9,
//     path: "/s-freezing",
//     entries: [
//       {
//         _id: "6822ea54b95a0152552879fb",
//         ivf_id: null,
//         ivf_flow_id: null,
//         created_at: "2025-05-13T06:44:35.028Z",
//         updated_at: "2025-10-03T11:35:24.161Z",
//       },
//     ],
//   },
//   {
//     name: "Sperm DFI",
//     count: 1,
//     icon: 10,
//     path: "/dna",
//     entries: [
//       {
//         _id: "6822eaf3b95a015255287a45",
//         ivf_id: null,
//         ivf_flow_id: null,
//         created_at: "2025-05-13T06:47:14.485Z",
//         updated_at: null,
//       },
//     ],
//   },
//   {
//     name: "IUI",
//     count: 1,
//     icon: 11,
//     path: "/iui",
//     entries: [
//       {
//         _id: "6823058fb95a015255287c4f",
//         ivf_id: null,
//         ivf_flow_id: null,
//         created_at: "2025-05-13T08:40:45.803Z",
//         updated_at: "2025-05-13T08:40:45.803Z",
//       },
//     ],
//   },
//   {
//     name: "SST",
//     count: 1,
//     icon: 12,
//     path: "/sst",
//     entries: [
//       {
//         _id: "682306efb95a015255287cf3",
//         ivf_id: null,
//         ivf_flow_id: null,
//         created_at: "2025-05-13T08:46:37.971Z",
//         updated_at: "2025-05-14T07:25:14.424Z",
//       },
//     ],
//   },
//   {
//     name: "Discharge Summary",
//     count: 1,
//     icon: 13,
//     path: "/discharge-card",
//     entries: [
//       {
//         _id: "682310bcb95a015255287ea2",
//         ivf_id: "2024/8/268-2",
//         ivf_flow_id: "67ca8c11cc105180b3113f63",
//         created_at: "2025-05-13T09:28:27.254Z",
//         updated_at: "2025-10-16T10:32:01.283Z",
//       },
//     ],
//   },
//   {
//     name: "Luteal Phase",
//     count: 2,
//     icon: 14,
//     path: "/luteal-phase",
//     entries: [
//       {
//         _id: "682310aab95a015255287e71",
//         ivf_id: "2024/8/268-2",
//         ivf_flow_id: "67ca8c11cc105180b3113f63",
//         created_at: "2025-05-13T09:28:09.348Z",
//         updated_at: "2025-05-13T09:28:09.348Z",
//       },
//       {
//         _id: "690add8a5cf516f924fff194",
//         ivf_id: "2025/9/268-1",
//         ivf_flow_id: "68d4dc0a794cbc18480319e8",
//         created_at: "2025-11-05T05:15:53.395Z",
//         updated_at: "2025-11-05T09:52:39.158Z",
//       },
//     ],
//   },
//   {
//     name: "Embryo Bank",
//     count: 1,
//     icon: 15,
//     path: "/embryo-bank",
//     entries: [
//       {
//         _id: "68c3f165b323a19076fa88d8",
//         ivf_id: "2024/8/268-2",
//         ivf_flow_id: "67ca8c11cc105180b3113f63",
//         created_at: "2025-09-12T10:09:39.634Z",
//         updated_at: "2025-09-12T10:09:39.634Z",
//       },
//     ],
//   },
//   {
//     name: "Cycle Out Come",
//     count: 1,
//     icon: 16,
//     path: "/cycle-out-come",
//     entries: [
//       {
//         _id: "68232e8079524449997ecad9",
//         ivf_id: "2024/8/268-2",
//         ivf_flow_id: "67ca8c11cc105180b3113f63",
//         created_at: "2025-05-14T07:37:50.761Z",
//         updated_at: "2025-05-14T07:37:50.761Z",
//       },
//     ],
//   },
//   {
//     name: "PGT Discharge Card",
//     count: 1,
//     icon: 17,
//     path: "/pgs-discharge-card",
//     entries: [
//       {
//         _id: "682319788c62556626bd5e6e",
//         ivf_id: "2024/8/268-2",
//         ivf_flow_id: "67ca8c11cc105180b3113f63",
//         created_at: "2025-05-13T10:05:43.406Z",
//         updated_at: "2025-10-17T06:38:38.699Z",
//       },
//     ],
//   },
//   {
//     name: "TESA/PESA Discharge Card",
//     count: 1,
//     icon: 18,
//     path: "/tesa-pesa-discharge-card",
//     entries: [
//       {
//         _id: "68231168b95a015255287ec5",
//         ivf_id: "2024/8/268-2",
//         ivf_flow_id: "67ca8c11cc105180b3113f63",
//         created_at: "2025-05-13T09:31:18.713Z",
//         updated_at: "2025-10-17T06:43:04.036Z",
//       },
//     ],
//   },
//   {
//     name: "Add Document",
//     count: 1,
//     icon: 19,
//     path: "/add-document",
//     entries: [
//       {
//         _id: "6916f569dbf63d46c73e99ee",
//         ivf_id: null,
//         ivf_flow_id: null,
//         created_at: "2025-11-14T09:24:57.091Z",
//         updated_at: null,
//       },
//     ],
//   },
// ];

const PhasePatientList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const defaultTheme = localStorage.getItem("default-theme") || "light";

  const [theme, setTheme] = useState(defaultTheme);
  const [activeModuleEntry, setActiveModuleEntry] = useState({});

  const { moduleList, selectedLocation } = useSelector(({ role }) => role);
  const { activePatient, selectedPatientJourneyInfo } = useSelector(
    ({ dashboard }) => dashboard
  );

  const { patient = {}, completed_pages = [] } = selectedPatientJourneyInfo;

  useEffect(() => {
    const interval = setInterval(() => {
      const current = localStorage.getItem("default-theme");
      if (current !== theme) {
        setTheme(current);
      }
    }, 5);
    return () => clearInterval(interval);
  }, [theme]);

  const onShowModuleDetail = (module, moduleEntry) => {
    setActiveModuleEntry(module.name);

    const selectedModule =
      moduleList?.find((item) => {
        if (item?.submenu?.length > 0) {
          return item?.submenu?.find((subMenu) => {
            return (
              subMenu?.module_actual_name?.toLowerCase() ===
              module?.name?.toLowerCase()
            );
          });
        }
        return (
          item?.module_actual_name?.toLowerCase() ===
          module?.name?.toLowerCase()
        );
      }) || {};

    const payload = {
      type: module.name,
      location_id: selectedLocation,
      patient_reg_id: activePatient._id,
      // patient_reg_id: "666c2455f471447f9e671510",
      ivf_flow_id: moduleEntry.ivf_flow_id,
      module_id: selectedModule?._id,
      _id: moduleEntry._id,
    };

    dispatch(setActivePatientJourneyModuleDetails({}));
    dispatch(dashboardViewPatientInfo(payload));
  };

  const moduleRedirectOnNextStep = () => {
    dispatch(setPatientEdit(activePatient));
    localStorage.setItem(
      "userLocation",
      window.btoa(JSON.stringify(activePatient.location_id))
    );
    sendDataToSocket("JUR", {
      room_id: activePatient.location_id,
    });
    dispatch(setSelectedLocation(activePatient.location_id));
    dispatch(getPermissionLocationWise(activePatient.location_id));
  };

  const handleEditModuleForSelectedPatient = (module, moduleEntry) => {
    moduleRedirectOnNextStep();

    if (module?.name === "IUI") {
      navigate("/iui-h-d", { state: { journey: "/iui-h-d" } });
    } else {
      navigate(module?.path, { state: { journey: module?.path } });
    }
  };

  const onRedirectForCreatePatient = () => {
    navigate("/patient-registration");

    dispatch(setSelectedModuleTab("2"));
  };

  return (
    <>
      <div className="patient-journey">
        {!Object.keys(activePatient)?.length ? (
          <div className="no-data">
            <div className="timeline-data-img">
              {/* <img
                src={
                  theme === "light"
                    ? TimelineDataNoFound
                    : DarkTimelineDataNoFound
                }
                alt="timeline-data-no-found"
              /> */}
              <img
                src={IVFProSoftLogo10}
                alt="timeline-data-no-found"
              />
            </div>
            <button
              className="btn_primary"
              onClick={onRedirectForCreatePatient}
            >
              <PlusOutlined className="m-0 me-md-2" />
              <span className="d-none d-md-inline-block">Add Patient</span>
            </button>
          </div>
        ) : (
          <>
            <h3 class="mb-3">
              Journey{" "}
              <span className="patient-name">{`(${
                patient?.patient_full_name ?? ""
              })`}</span>
            </h3>
            <div class="timeline">
              {completed_pages?.map((module, index) => {
                return module.entries.map((item) => {
                  return (
                    <div
                      class={`timeline-card ${
                        index % 2 === 0 ? "right" : "left"
                      }`}
                    >
                      <div class="date">
                        {formatDateToDDMMYYYY(item.created_at)}
                      </div>
                      <div class="icon">
                        <img src={handleModuleWiseIcon(module.icon)} alt="" />
                      </div>
                      <div class="content">
                        <h2>
                          <div className="checked-icon">
                            <img src={CheckedIcon} alt="" />
                          </div>
                          {`${module.name} ${item?.ivf_id ?? ""}`}
                        </h2>
                        <div class="timeline-event">
                          <button
                            onClick={() =>
                              handleEditModuleForSelectedPatient(module, item)
                            }
                          >
                            <img src={EditIconImg} alt="" />{" "}
                          </button>
                          {module?.icon !== 15 && (
                            <button>
                              <img
                                src={ViewIconImg}
                                alt=""
                                onClick={() => onShowModuleDetail(module, item)}
                              />
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                });
              })}

              <button
                className="btn_border next_step_btn"
                onClick={moduleRedirectOnNextStep}
              >
                Next Step
                <img src={RightArrowImg} alt="" />{" "}
              </button>
            </div>

            {activeModuleEntry === "Patient Registration" && (
              <PatientRegistrationModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Patient Basic History" && (
              <PatientBasicHistoryModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Patient Extended History" && (
              <PatientExtendedHistoryModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Male Infertility Investigation" && (
              <MaleInfertilityInvestigationModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Female Infertility Investigation" && (
              <FemaleInfertilityInvestigationModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "IVF Flow Sheet" && (
              <IvfFlowSheetModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Embryology Data Sheet" && (
              <EmbryologyDataSheetModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Semen Analysis" && (
              <SemenAnalysisModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Sperm Freezing" && (
              <SFreezingModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Sperm DFI" && (
              <DNAModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "IUI" && (
              <IUIModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "SST" && (
              <SSTModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Discharge Summary" && (
              <DischargeCardModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Luteal Phase" && (
              <LutealPhaseModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Embryo Bank" && (
              <EmbryoBankModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "Cycle Out Come" && (
              <CycleOutComeModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "PGT Discharge Card" && (
              <PGTDischargeCardModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
            {activeModuleEntry === "TESA/PESA Discharge Card" && (
              <TesaPesaDischargeCardModal
                isOpen
                onClose={() => setActiveModuleEntry(null)}
                activeModuleEntry={activeModuleEntry}
              />
            )}
          </>
        )}
      </div>
    </>
  );
};

export default memo(PhasePatientList);
